import "core-js/modules/es.array.for-each";
import "core-js/modules/web.dom-collections.for-each";
import _objectSpread from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  props: {
    form: {
      type: Object,
      default: {}
    }
  },
  data: function data() {
    return {
      yingye: {
        edit: false,
        rules: {}
      },
      contactList: [{
        name: '',
        position: '',
        phone: ''
      }, {
        name: '',
        position: '',
        phone: ''
      }, {
        name: '',
        position: '',
        phone: ''
      }]
    };
  },
  methods: {
    clickEdit: function clickEdit() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!_this.yingye.edit) {
                  _context.next = 6;
                  break;
                }

                _this.yingye.edit = false;
                _context.next = 4;
                return _this.onSubmit(_objectSpread(_objectSpread({}, _this.form), {}, {
                  contactList: _this.contactList
                }));

              case 4:
                _context.next = 7;
                break;

              case 6:
                _this.yingye.edit = true;

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    onSubmit: function onSubmit(item) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var loading;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                loading = _this2.$loading({
                  lock: true,
                  text: 'Loading',
                  spinner: 'el-icon-loading',
                  background: 'rgba(0, 0, 0, 0.7)'
                });
                _context2.next = 3;
                return _this2.$api.updateInformation(item);

              case 3:
                YL.message('保存成功');
                loading.close();
                return _context2.abrupt("return", true);

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    }
  },
  computed: {
    yingyeEdit: function yingyeEdit() {
      return this.yingye.edit;
    }
  },
  created: function created() {
    var _this3 = this;

    this.form.contactList.forEach(function (l, i) {
      _this3.contactList[i] = l;
    });
  }
};